<!-- 单位授信历史 -->
<template>
    <div class='page_content'>
        <processAuditAction ref="processAuditAction"></processAuditAction>

        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :buttonFlag="false"></v-button>
            <div class="page_content_top_line">
                <el-form :inline="true" :model="getRequestData" class="demo-form-inline" size="mini" label-width="100px">
                    <el-form-item label="开始时间">
                        <label slot="label" :style="$common.labelStyle('开始时间')" v-html="$common.htmlLabel('开始时间')"></label>
                        <el-date-picker class="form_codition" size="mini" v-model="getRequestData.start" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间">
                        <label slot="label" :style="$common.labelStyle('结束时间')" v-html="$common.htmlLabel('结束时间')"></label>
                        <el-date-picker class="form_codition" size="mini" v-model="getRequestData.end" @change="changeTime" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date"
                                        placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="单位名称">
                        <label slot="label" :style="$common.labelStyle('单位名称')" v-html="$common.htmlLabel('单位名称')"></label>
                        <el-input class="form_codition" v-model="getRequestData.unitName" clearable :maxlength="$store.state.inputLength"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div class="page_content_center">
            <el-table stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }" style="width: 100%"
                      highlight-current-row size="mini">
                <el-table-column label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="unitName" label="单位名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="snapCreditamount" label="临时信贷额"></el-table-column>
                <el-table-column show-overflow-tooltip prop="snapCreditperiod" label="临时信贷期"></el-table-column>
                <el-table-column show-overflow-tooltip prop="creditamount" label="信贷额"></el-table-column>
                <el-table-column show-overflow-tooltip prop="creditperiod" label="信贷期"></el-table-column>
                <el-table-column show-overflow-tooltip prop="crType" label="单位类型">
                    <template slot-scope="scope">
                        <span>{{ scope.row.crType == 0 ? '供货商' : '客户' }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="crStatus" label="状态">
                    <template slot-scope="scope">
                        <el-tag size="mini">{{ getIsGsp(scope.row.crStatus) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="applyReason" label="申请原因"></el-table-column>
                <el-table-column show-overflow-tooltip label="有效期" prop="expidate" min-width="100">
                    <template slot-scope="scope">
                        <div>
                            {{ $common.getLocalTime(scope.row.validity) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="申请日期" prop="expidate" min-width="100">
                    <template slot-scope="scope">
                        <div>
                            {{ $common.getLocalTime(scope.row.createTime) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="回款日期" prop="paymentDate" min-width="100">
                    <template slot-scope="scope">
                        <div>
                            {{ $common.getLocalTime(scope.row.paymentDate) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="paymentAmount" label="回款金额"></el-table-column>
                <el-table-column show-overflow-tooltip prop="invoiceAmount" label="开票金额"></el-table-column>
                <el-table-column show-overflow-tooltip prop="overdueAmount" label="超账期金额"></el-table-column>
            </el-table>
        </div>

        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                creater: '',
                page: 1,
                rows: 30,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
                ormId: '',
                unitName: "",
                opmId: '',
                opmName: '',
                "crType": '',
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            seId: "",
            seWidth: "",
            seTitle: "",
            seWidth: "",
            DialogVisible: false,
            seType: '',
            sField: "",
            isShowTooltip: false,
            parentSearchData: {}

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        // 'getRequestData.bsmPersonName':{
        //     handler(newVal){
        //         if(newVal == '') this.getRequestData.opmId = ''
        //     },
        //     deep: true
        // }
        "getRequestData.opmName"() {
            if (this.getRequestData.opmName == '') {
                this.getRequestData.opmId = ''
            }
        },
    },
    //方法集合
    methods: {
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },

        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }

        },

        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.seId = sId
            // this.seType = type
            this.DialogVisible = true
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        //提取返回
        changeInputModel(val) {
            // console.log(this.seType,val)

            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (val.opmId) {
                    this.paramValue(val)
                }
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e, "555555")
            this.seTitle = e;
        },

        // 动作集合
        actionSet(actionData) {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            switch (actionData.actionType) {
                case 5:
                    this.$refs['processAuditAction'].openBox(1, dataInfo.crId)
                    break;
            }
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.pageFormText({
                ids: [pathId.jurId]
            })
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getUnitCreditQueryUnitCreditHis(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.pages = responseData.result.pages
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
                this.selectedDataIndex = 0
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },
        //获得状态
        getIsGsp(val) {
            let str = '[{"key":-1,"value":"审核退回"},{"key":0,"value":"初始"},{"key":1,"value":"已提交"},{"key":2,"value":"审核通过"}]'
            try {
                if (str.indexOf('[') === -1) return val
                str && str.replace(/\\/g, '')
                let arr = JSON.parse(str)
                let len = arr.length
                let newStr = ''
                for (let i = 0; i < len; i++) {
                    if (arr[i].key == val) {
                        newStr = arr[i].value
                        break;
                    }
                }
                return newStr ? newStr : val
            } catch (ex) {
                return val
            }
        },
        //结束时间改成最后时间
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1
                this.getRequestData.end = time
            }
        },


    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        // this.getPageInfo()
        var objs = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        for (const key in objs) {
            this.$set(this.getRequestData, key, objs[key])
        }
        this.getDataList()
        this.getButtonList()

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
}
</style>
